module.exports = __webpack_public_path__ + "static/media/Q8-4.53c46621.jpg";